export default __webpack_public_path__ + "static/media/linkedin-logo.6ac12815.png";